/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SharedItemTile_item = {|
  +serviceId: ?string;
  +measurement: ?{|
    +dimensions: ?$ReadOnlyArray<?{|
      +unit: ?string;
      +value: ?string;
    |}>;
    +size: ?{|
      +value: ?string;
    |};
  |};
  +browseUrl: ?string;
  +categoryCode: ?string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "showSeller",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_item",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Tile_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller",
          "type": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "name": "measurement",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "dimensions",
          "args": [
            {
              "kind": "Literal",
              "name": "addLabel",
              "value": true,
              "type": "Boolean"
            },
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "height",
                "width",
                "depth",
                "diameter"
              ],
              "type": "[measurementFieldType]"
            },
            {
              "kind": "Literal",
              "name": "separator",
              "value": " ",
              "type": "String"
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "name": "display",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "unit",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": "display{\"addLabel\":true,\"fields\":[\"height\",\"width\",\"depth\",\"diameter\"],\"separator\":\" \"}"
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "ItemSize",
          "name": "size",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "browseUrl",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "categoryCode",
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
